import {
  Container,
  TopLeft,
  BottomLeft,
  BottomRight,
  TopRight,
  Tagline,
  SectionLabel,
  SpotlightSection,
  SpotlightLogo,
  SpotlightCaption,
  CaptionLink,
  ResearchSection,
  ResearchLogo,
  EmailLink
} from './styles'
import { Logo } from './Logo'

export default function Overlay() {
  return (
    <Container>
      <TopLeft>
        <h1>
          Org.anically
          <br />
          D.isruptive
        </h1>
        <Tagline>Creators of Languages / Intelligences / Worlds</Tagline>
        
        <SpotlightSection className="shouldHide">
          <SectionLabel>R&D Projects:</SectionLabel>
          <a href="https://www.tolmix.com" target="_blank" rel="noreferrer">
            <SpotlightLogo src="social_banner_small.jpg" alt="Tolmix" $width="385px" $height="auto"/>
          </a>
          <SpotlightCaption>
            <CaptionLink href="https://www.tolmix.com" target="_blank" rel="noreferrer">tolmix.com</CaptionLink> the first AIR Network
          </SpotlightCaption>
        </SpotlightSection>
      </TopLeft>

      <BottomLeft>
        <p>Abbraccia Ogne Speranza Voi Ch' Entrate</p>
      </BottomLeft>

      <BottomRight>
        We operate in the areas of AI/VR, Programming Languages and Tools.
        <br />
        <br />
        We take on "improbable" R&D projects, training your engineers beyond the state of art.
      </BottomRight>

      <TopRight>
        <div>
          Contact:{' '}
          <EmailLink href="mailto:research@orgdlabs.com">research@orgdlabs.com</EmailLink>
        </div>

        <ResearchSection className="shouldHide">
          <SectionLabel>Research Projects:</SectionLabel>
          <a href="https://arxiv.org/abs/2501.00169" target="_blank" rel="noreferrer">
            <ResearchLogo src="DeepLL.png" alt="DeepLL" />
          </a>
          <a href="neuroQL" target="_blank" rel="noreferrer">
            <ResearchLogo src="neuroQL_logo_transparent_crop.png" alt="NeuroQL" $height="175px" $width="auto" />
          </a>
        </ResearchSection>
      </TopRight>

      <Logo />
    </Container>
  )
}
